/* Cupid World loyalty pill. Rendered by snippets/loyalty-pill.liquid, which prints the
   markup and the #LoyaltyPillConfig JSON this file reads. Loaded deferred, so it runs once
   the page is parsed and is cached across pages. No Liquid in here on purpose. */
  (function () {
    var root = document.getElementById('LoyaltyPill');
    var cfgEl = document.getElementById('LoyaltyPillConfig');
    if (!root || !cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    /* ---------- pop-up sign-in: the window Shopify sends back ----------
       On desktop the sign-in opens in a small window and Shopify returns it
       to this page with ?sc_lpill=signed-in. That window's only job is to
       tell the page that opened it, then close. If it was not opened by
       script (blocked pop-up, link copied), it just carries on as a page. */
    if (/[?&]sc_lpill=signed-in(&|$)/.test(location.search)) {
      var popOpener = null;
      try { popOpener = window.opener; } catch (e) {}
      if (popOpener && !popOpener.closed) {
        try { document.documentElement.style.visibility = 'hidden'; } catch (e) {}
        try { popOpener.postMessage({ scLpill: 'signed-in', member: !!cfg.member }, location.origin); } catch (e) {}
        window.close();
        return;
      }
      try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])sc_lpill=signed-in(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/\?$/, '') + location.hash); } catch (e) {}
    }
    var btn = root.querySelector('[data-lpill-btn]');
    var textEl = root.querySelector('[data-lpill-text]');
    var minBtn = root.querySelector('[data-lpill-min]');
    var panel = document.getElementById('LoyaltyPillPanel');
    var state = cfg.member ? 'member' : 'guest';
    var MIN_KEY = 'sc-lpill-min';

    /* For opening by itself (see "open by itself" below), from the first
       line so every page of the visit counts and no Klaviyo pop-up is
       missed: pages seen this visit, Klaviyo pop-ups shown this visit, and
       whether the panel on screen is one that opened by itself. */
    var AUTO_PV_KEY = 'sc-lpill-pages';
    var AUTO_DONE_KEY = 'sc-lpill-auto-done';
    var AUTO_AT_KEY = 'sc-lpill-auto-at';
    var OPENED_KEY = 'sc-lpill-opened';
    var KL_SHOWN_KEY = 'sc-lpill-kl-shown';
    var pagesThisVisit = 1;
    try { pagesThisVisit = Number(sessionStorage.getItem(AUTO_PV_KEY) || 0) + 1; sessionStorage.setItem(AUTO_PV_KEY, String(pagesThisVisit)); } catch (e) {}
    var autoOpening = false;
    var autoShowing = false;
    var klaviyoOpen = false;
    window.addEventListener('klaviyoForms', function (e) {
      var t = e && e.detail && e.detail.type;
      if (t === 'open') {
        klaviyoOpen = true;
        try { sessionStorage.setItem(KL_SHOWN_KEY, '1'); } catch (x) {}
        /* The pop-up keeps its own timing; if it opens over a panel that opened by itself, the pop-up wins. */
        if (autoShowing) closePanel();
      } else if (t === 'close') {
        klaviyoOpen = false;
      }
    });

    /* GA4 gets the event straight from the page's gtag function. Only that copy is sent: a
       dataLayer push as well was picked up by Elevar's Tag Manager container and forwarded to GA4
       a second time without the step parameter, doubling the count. Events fired before gtag.js
       is ready wait for it, for up to 20 seconds. lp_sent_via marks the copy. */
    var gtagQueue = [], gtagTimer = null, gtagTries = 0;
    function viaGtag(p) {
      if (typeof window.gtag !== 'function') {
        gtagQueue.push(p);
        if (!gtagTimer) gtagTimer = setInterval(function () {
          if (typeof window.gtag !== 'function') { if (++gtagTries >= 20) { clearInterval(gtagTimer); gtagTimer = null; gtagQueue = []; } return; }
          clearInterval(gtagTimer); gtagTimer = null;
          gtagQueue.splice(0).forEach(viaGtag);
        }, 1000);
        return;
      }
      var e = { lp_sent_via: 'gtag' };
      for (var k in p) if (k !== 'event') e[k] = p[k];
      window.gtag('event', 'loyalty_pill', e);
    }
    function track(action, extra) {
      try {
        var p = { event: 'loyalty_pill', lp_action: action, lp_state: state, lp_market: cfg.market };
        if (extra) for (var k in extra) p[k] = extra[k];
        viaGtag(p);
      } catch (e) {}
    }

    /* ---------- money in the shopper's currency ---------- */
    var rate = 1;
    var local = cfg.currency && cfg.currency !== cfg.shopCurrency;
    if (local) {
      var r = window.Shopify && Shopify.currency && Number(Shopify.currency.rate);
      rate = r > 0 ? r : 0;
    }
    function money(shopAmount, roundUp) {
      if (local && (!rate || cfg.moneyOutside === 'points')) return '';
      var v = shopAmount * rate;
      if (roundUp && local) v = Math.ceil(v);
      var whole = Math.abs(v - Math.round(v)) < 0.005;
      try {
        var s = new Intl.NumberFormat('en-GB', { style: 'currency', currency: cfg.currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(v);
        return local ? 'about ' + s : s;
      } catch (e) { return ''; }
    }
    function pointsValue(points) { return money(points / cfg.pointsPerUnit); }
    function fmtPoints(n) { return Number(n).toLocaleString('en-GB'); }

    function tierRate() {
      var rate = Number(cfg.earnRate) || 3;
      if (cfg.tier && cfg.tierRates) {
        cfg.tierRates.split(',').forEach(function (pair) {
          var bits = pair.split(':');
          if (bits.length === 2 && bits[0].trim().toLowerCase() === cfg.tier.toLowerCase()) rate = Number(bits[1]) || rate;
        });
      }
      return rate;
    }
    /* The spend unit points are earned on: "\u00a31" at home, "\u00a31 (about US$1.34)" in another currency,
       "pound" when no rate is known. Never a bare pound sign where the shopper pays in something else. */
    function unitText() {
      if (cfg.currency === cfg.shopCurrency) return '\u00a31';
      var u = money(1);
      return u ? '\u00a31 (' + u + ')' : 'pound';
    }
    /* The highest earn rate across the VIP tiers, from the tier rates setting ("Angel Apartments:5,Cupid Castle:7"). */
    function topRate() {
      var top = Number(cfg.earnRate) || 3;
      String(cfg.tierRates || '').split(',').forEach(function (pair) { var n = Number((pair.split(':')[1] || '').trim()); if (n > top) top = n; });
      return top > (Number(cfg.earnRate) || 3) ? top : Math.max(top, 7);
    }
    function earnRateText(r) {
      return r + ' points for every ' + unitText() + ' you spend';
    }

    /* The skin type as a word: "oily" from "Oily Skin". */
    function typeShort() {
      var t = (typeof current !== 'undefined' && current && current.type) ? String(current.type) : '';
      return t.toLowerCase().replace(/\bskin\b/g, '').replace(/\s+/g, ' ').trim();
    }
    /* Tokens: [programme] [join_points] [join_value] [earn_rate] [unit] [top_rate] [min_redeem] [points]
       [value] [to_reward] [min_order] [profile_points] [type_short]. A token whose money value is hidden for this
       market falls back to points, and "  · " left dangling is tidied. */
    function fill(tpl, v) {
      var joinVal = pointsValue(cfg.joinPoints);
      var map = {
        programme: cfg.programme,
        first_name: cfg.firstName || '',
        offer: cfg.offerText,
        offer_short: cfg.offerShort || cfg.offerText,
        code: cfg.offerCode || '',
        join_points: fmtPoints(cfg.joinPoints),
        email_points: fmtPoints(cfg.emailPoints),
        join_value: joinVal || (fmtPoints(cfg.joinPoints) + ' points'),
        earn_rate: earnRateText(tierRate()),
        points: v && v.points != null ? fmtPoints(v.points) : '',
        value: v && v.value != null ? (money(v.value) || fmtPoints(v.points) + ' points') : '',
        to_reward: v && v.toReward != null ? fmtPoints(v.toReward) : '',
        min_order: money(cfg.minOrder, true) || ('\u00a3' + cfg.minOrder + (local ? ' or the equivalent' : '')),
        unit: unitText(),
        top_rate: String(topRate()),
        rate: String(tierRate()),
        min_redeem: fmtPoints(cfg.minRedeem || 100),
        profile_points: fmtPoints((cfg.profile && cfg.profile.points) || 0),
        type_short: typeShort()
      };
      return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map.hasOwnProperty(k) ? map[k] : m; })
        .replace(/\s*\u00b7\s*$/, '').replace(/^\s*\u00b7\s*/, '').trim();
    }
    /* Text for innerHTML: everything escaped, then **words** become <strong>, so the theme
       editor can bold a callout in any line without being able to add markup. */
    function bold(t) {
      return String(t || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; })
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    }

    function setText(t) { if (textEl && t) { textEl.textContent = t; btn.setAttribute('aria-label', t); } }

    /* ---------- panel ----------
       Guests: what joining is worth, an email box and an unticked email
       tickbox, then the button sends them to Shopify's sign-in with the
       email filled in (the code arrives by email; the account and its Rivo
       points are created there). Ticking subscribes them in Klaviyo first,
       with the source recorded, so consent never depends on Rivo's form.
       Members without email consent: the same panel asks once, and the
       button is the consent. */
    var mode = cfg.member ? 'member' : 'guest';
    function accentTitle(title, accent, isName) {
      var titleEl = panel.querySelector('[data-lpill-title]');
      var at = accent ? title.indexOf(accent) : -1;
      titleEl.textContent = '';
      if (at > -1) {
        var em = document.createElement('em');
        em.className = 'lpill-panel__accent' + (isName ? ' lpill-panel__accent--name' : '');
        em.textContent = accent;
        titleEl.appendChild(document.createTextNode(title.slice(0, at)));
        titleEl.appendChild(em);
        titleEl.appendChild(document.createTextNode(title.slice(at + accent.length)));
      } else {
        titleEl.textContent = title;
      }
    }
    function buildPanel() {
      if (!panel) return;
      var ul = panel.querySelector('[data-lpill-perks]');
      var lede = panel.querySelector('[data-lpill-lede]');
      var note = panel.querySelector('[data-lpill-note]');
      sayError('');
      var rewards = panel.querySelector('[data-lpill-rewards]');
      var earn = panel.querySelector('[data-lpill-earn]');
      var picks = panel.querySelector('[data-lpill-picks]');
      var legal = panel.querySelector('[data-lpill-legal]');
      var opts = panel.querySelector('[data-lpill-opts]');
      var skip = panel.querySelector('[data-lpill-skip]');
      var shopBtn = panel.querySelector('[data-lpill-shop]');
      if (shopBtn) shopBtn.hidden = true;
      rewards.hidden = true;
      if (earn) earn.hidden = true;
      if (picks) picks.hidden = true;
      opts.hidden = true; opts.innerHTML = '<legend class="sr-only" data-lpill-opts-legend></legend>';
      skip.hidden = true;
      renderCoupon('');
      if (mode === 'profile') {
        /* Two quick questions after joining or consenting: skin type (one),
           then concerns (any). Answers go to the same Klaviyo properties the
           welcome pop-up writes, so segments and flows keep working. */
        var pr = cfg.profile;
        var step2 = profileStep === 2;
        var list = step2 ? pr.concerns : pr.types;
        if (profileEdit) {
          accentTitle(fill(pr.editTitle), '');
          lede.textContent = step2 ? fill(pr.concernQ) : fill(editForPoints && pointsOn() ? pr.refreshLede : pr.editLede) + ' ' + fill(pr.typeQ);
        } else if (joinFlow) {
          /* Straight after joining: say hello, then ask. The code card follows. */
          var hello = fill(cfg.ordersCount === 0 ? cfg.text.welcomeNewTitle : cfg.text.welcomeBackTitle).replace(/,\s*!/, '!').replace(/,\s*$/, '');
          accentTitle(hello, fill('[first_name]'), true);
          /* A plain holding message: no points or offer promised until the card. */
          lede.textContent = step2 ? fill(pr.concernQ) : fill(cfg.text.profileIntro) + ' ' + fill(pr.typeQ);
        } else {
          /* Asked later (the nudge, the drawer, the /?sc=skin link): the points are part of the ask. */
          accentTitle(fill(pr.title), '');
          lede.textContent = step2 ? fill(pr.concernQ) : fill(pointsOn() ? pr.pointsLede : pr.lede) + ' ' + fill(pr.typeQ);
        }
        lede.hidden = false;
        ul.hidden = true;
        opts.querySelector('[data-lpill-opts-legend]').textContent = step2 ? pr.concernQ : pr.typeQ;
        list.forEach(function (o, i) {
          if (!o.label) return;
          var lab = document.createElement('label');
          lab.className = 'lpill-panel__opt';
          var inp = document.createElement('input');
          inp.type = step2 ? 'checkbox' : 'radio';
          inp.name = step2 ? 'lp_concern' : 'lp_type';
          inp.value = o.value;
          inp.checked = step2 ? profileAnswers.concerns.indexOf(o.value) > -1 : profileAnswers.type === o.value;
          lab.appendChild(inp);
          lab.appendChild(document.createTextNode(o.label));
          opts.appendChild(lab);
        });
        opts.hidden = false;
        panel.querySelector('[data-lpill-cta]').textContent = step2 ? fill(profileEdit ? pr.save : pr.done) : fill(pr.next);
        skip.textContent = fill(pr.skip);
        skip.hidden = profileEdit;
        legal.hidden = true;
        return;
      }
      legal.hidden = false;
      /* The welcome offer's own small print, only while the offer is on the table. */
      var offerLegal = legal.querySelector('[data-lpill-offer-legal]');
      if (offerLegal) {
        var offerOpen = cfg.offer && (mode === 'guest' || (cfg.offerEligible && !offerApplied && bridgeState !== 'used' && bridgeState !== 'ineligible'));
        if (offerOpen && !offerLegal.__filled) { offerLegal.textContent = fill(offerLegal.textContent); offerLegal.__filled = true; }
        offerLegal.hidden = !offerOpen;
      }
      note.textContent = '';
      note.hidden = true;
      if (mode === 'member') {
        if (cfg.offerEligible && !offerApplied && !cfg.offerCode && bridgeState !== 'used' && bridgeState !== 'ineligible') {
          /* A new member without email consent: the emails are how the first-order code arrives. */
          accentTitle(fill(cfg.text.memberOfferTitle), fill('[offer]'));
          lede.textContent = fill(cfg.text.memberOfferLede);
        } else {
          accentTitle(fill(cfg.text.memberTitle), fill('[email_points] bonus points'));
          lede.textContent = fill(cfg.text.memberLede);
        }
        lede.hidden = false;
        ul.hidden = true;
        panel.querySelector('[data-lpill-cta]').textContent = fill(cfg.text.memberCta);
        return;
      }
      if (mode === 'welcome') {
        /* The hello after sign-in (after the two questions, when asked), or
           the code card opened again from the pill later. */
        var fresh = cfg.ordersCount === 0;
        var tKey = joinFlow ? (profileDone ? cfg.text.welcomeDoneTitle : (fresh ? cfg.text.welcomeNewTitle : cfg.text.welcomeBackTitle)) : cfg.text.couponTitle;
        var t = fill(tKey).replace(/,\s*!/, '!').replace(/,\s*$/, '');
        accentTitle(t, joinFlow ? fill('[first_name]') : '', true);
        var welcomeCta = fill(cfg.text.welcomeCta);
        /* Rivo credits the joining points a moment after the account exists,
           so the balance can still be 0 or unknown here: then leave points
           out rather than promise "0 points". */
        var havePoints = lastPoints != null && lastPoints > 0;
        var coupon = '';
        /* Ordered before: Liquid's count, or the bridge's when the record is fresher. */
        var notNew = (cfg.offer && cfg.ordersCount > 0) || (cfg.offerEligible && bridgeState === 'ineligible');
        if (cfg.offerEligible && offerApplied) {
          lede.textContent = havePoints ? fill(cfg.text.welcomeOffer, { points: lastPoints }) : fill(cfg.text.welcomeOfferNoPoints);
          coupon = 'applied';
        } else if (cfg.offerEligible && bridgeState === 'used') {
          lede.textContent = fill(cfg.text.welcomeUsed);
        } else if (notNew) {
          /* The offer was promised before sign-in only to a visitor nobody recognised: say plainly why it does
             not apply, with their points. A recognised visitor was promised nothing, so just their points. */
          if (offerPromised) {
            var spendNow = Math.min(Math.floor(lastPoints / cfg.pointsPerUnit) * cfg.pointsPerUnit, cfg.maxRedeem);
            lede.textContent = havePoints ? fill(cfg.text.welcomeNotNew, { points: lastPoints, value: spendNow / cfg.pointsPerUnit }) : fill(cfg.text.welcomeNotNewNoPoints);
          } else {
            lede.textContent = havePoints ? pointsLine : fill(cfg.text.welcomeNoPoints);
          }
        } else if (cfg.offerEligible && cfg.offerCode && !bridgeBusy()) {
          /* Code known but the quiet apply failed: the button applies it. */
          lede.textContent = havePoints ? pointsLine : fill(cfg.text.welcomeNoPoints);
          welcomeCta = fill(cfg.text.welcomeOfferCta);
          coupon = 'ready';
        } else if (cfg.offerEligible && !cfg.offerCode && needsEmail()) {
          /* No email consent, so Klaviyo has no code for them yet: the button opens the email panel. */
          lede.textContent = fill(cfg.text.welcomeNeedsEmail);
          welcomeCta = fill(cfg.text.welcomeNeedsEmailCta);
        } else if (cfg.offerEligible && bridgeBusy()) {
          /* The bridge is still fetching or applying the code: the card fills in when it lands. */
          lede.textContent = havePoints ? fill(cfg.text.welcomeFinding, { points: lastPoints }) : fill(cfg.text.welcomeFindingNoPoints);
          coupon = 'finding';
        } else if (cfg.offerEligible) {
          /* The bridge has stopped asking without a code: it comes by email, and the pill picks it up on the next visit. */
          lede.textContent = fill(cfg.text.welcomePending);
        } else {
          lede.textContent = havePoints ? pointsLine : fill(cfg.text.welcomeNoPoints);
        }
        lede.hidden = false;
        ul.hidden = true;
        renderCoupon(coupon);
        panel.querySelector('[data-lpill-cta]').textContent = welcomeCta;
        if (earn) earn.hidden = false;
        if (picks && (current.type || current.concerns.length)) picks.hidden = false;
        if (pointsDue && cfg.profile && cfg.profile.pointsNote) { note.textContent = fill(cfg.profile.pointsNote); note.hidden = false; }
        rewards.hidden = false;
        legal.hidden = true;
        return;
      }
      if (mode === 'known') {
        /* Klaviyo knows this device: lead with sign-in, keep the offer. */
        accentTitle(fill(cfg.text.knownTitle), '');
        lede.textContent = fill(cfg.text.knownLede);
        lede.hidden = false;
        ul.hidden = true;
        /* No marketing tick box here: a returning visitor may already be
           subscribed, and we cannot tell while they are signed out. The
           member panel asks instead, and only if Shopify says they are not. */
        var kc = panel.querySelector('.lpill-panel__check');
        if (kc) { kc.hidden = true; var ki = kc.querySelector('input'); if (ki) ki.checked = false; }
        var kl = panel.querySelector('[data-lpill-consent-line]'); if (kl) kl.hidden = true;
        panel.querySelector('[data-lpill-cta]').textContent = fill(cfg.text.knownCta);
        /* Klaviyo may know them from the old pop-up alone, with no account:
           the same sign-in creates one, so say so. No email consent is
           asked for here, so no small print either. */
        note.textContent = fill(cfg.text.knownNote);
        note.hidden = !cfg.text.knownNote;
        legal.hidden = true;
        prefillEmail();
        if (shopBtn) { shopBtn.hidden = false; armShopWatch(); }
        return;
      }
      prefillEmail();
      if (cfg.offer) accentTitle(fill(cfg.text.panelTitleOffer), fill('[offer]'));
      else accentTitle(fill(cfg.text.panelTitle), fill('[join_value]'));
      lede.hidden = true;
      var perks = (cfg.text.panelPerks || '').split(/\n+/).map(function (s) { return s.trim(); }).filter(Boolean);
      if (!perks.length) {
        perks = ['**[join_points] points** ([join_value]) as soon as you join', '**[email_points] bonus points** for joining our emails', '**[rate] points for every [unit]** you spend', '**Birthday points**, plus higher tiers that earn up to [top_rate] points per [unit]', '**Spend from [min_redeem] points** on full-price products' + (Number(cfg.minOrder) > 0 ? ', on orders over [min_order]' : '')];
        if (cfg.offer) perks.unshift('**[offer_short]** your first order, applied at checkout');
      }
      ul.innerHTML = '';
      perks.forEach(function (p) {
        var li = document.createElement('li');
        /* One span per line: the li is a flex row (spark, then words), so the words must stay one item. */
        li.innerHTML = '<span>' + bold(fill(p).replace(/\(\s*\d[\d,]* points\s*\)/, '').replace(/\s{2,}/g, ' ')) + '</span>';
        ul.appendChild(li);
      });
      ul.hidden = false;
      var cl = panel.querySelector('[data-lpill-consent-label]');
      if (cl) cl.innerHTML = bold(fill(cfg.text.consentLabel));
      /* Email sign-up: a line saying joining signs them up (no box), or a tick box, ticked or not
         by the setting unless the shopper has already changed it. */
      var implied = cfg.consentMode === 'implied';
      var gl = panel.querySelector('[data-lpill-consent-line]');
      if (gl) { gl.innerHTML = bold(fill(cfg.text.consentLine)); gl.hidden = !implied; }
      var gc = panel.querySelector('.lpill-panel__check');
      if (gc) {
        gc.hidden = implied;
        var gi = gc.querySelector('input');
        if (gi && !implied && !gi.hasAttribute('data-touched')) {
          gi.checked = cfg.consentMode === 'ticked';
          gi.addEventListener('change', function () { gi.setAttribute('data-touched', '1'); });
        }
      }
      panel.querySelector('[data-lpill-cta]').textContent = fill(cfg.text.panelCta);
      note.textContent = fill(cfg.text.panelNote);
      note.hidden = false;
    }
    function sayError(t) {
      var el = panel && panel.querySelector('[data-lpill-error]');
      if (!el) return;
      el.textContent = t || '';
      el.hidden = !t;
    }

    /* Klaviyo's public client API, the same one the EPII sign-up uses. */
    var SUB_KEY = 'sc-lpill-subscribed';
    /* Elevar: an email consent is a lead for every destination Elevar feeds (GA4, Meta, Klaviyo),
       so the same sign-up is counted there as a newsletter form would be. Only once Klaviyo has it. */
    function leadToElevar(email) {
      try {
        if (window.ElevarDataLayer && typeof window.ElevarDataLayer.push === 'function') {
          window.ElevarDataLayer.push({ event: 'dl_subscribe', lead_type: 'email', user_properties: { customer_email: email } });
        }
      } catch (e) {}
    }
    function subscribe(email) {
      if (!cfg.klaviyoKey || !cfg.klaviyoList) return Promise.reject(new Error('Klaviyo not set up'));
      var payload = { data: { type: 'subscription', attributes: {
        custom_source: cfg.klaviyoSource,
        profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      }, relationships: { list: { data: { type: 'list', id: cfg.klaviyoList } } } } };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.klaviyoKey), {
        method: 'POST',
        keepalive: true,
        headers: { 'content-type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('Klaviyo ' + r.status);
        try { localStorage.setItem(SUB_KEY, '1'); } catch (e) {}
        sendBase(email);
      });
    }
    function withTimeout(p, ms) {
      return Promise.race([p, new Promise(function (res, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
    }
    function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
    var JOIN_KEY = 'sc-lpill-join';
    var EMAIL_KEY = 'sc-lpill-email';
    /* Whether the pill promised the offer before sign-in: only to a visitor nobody recognised
       ("[offer] · tap to join"); a recognised visitor saw "Welcome back" and no offer. Read back
       after sign-in with the join flag, so the hello card knows whether to explain the offer. */
    var PROMISED_KEY = 'sc-lpill-promised';
    var offerPromised = false;
    function notePromise() {
      try { if (state === 'guest' && cfg.offer) sessionStorage.setItem(PROMISED_KEY, '1'); else sessionStorage.removeItem(PROMISED_KEY); } catch (e) {}
    }
    /* The address to fill the email box with: what this device last signed in with through
       the pill, else the email Klaviyo keeps in its own first-party cookie (__kla_id). */
    function rememberedEmail() {
      var v = '';
      try { v = localStorage.getItem(EMAIL_KEY) || ''; } catch (e) {}
      if (!v) {
        try {
          var m = /(?:^|;\s*)__kla_id=([^;]*)/.exec(document.cookie || '');
          if (m) { var j = JSON.parse(atob(decodeURIComponent(m[1]))); v = (j && (j.$email || j.email)) || ''; }
        } catch (e) { v = ''; }
      }
      return validEmail(v) ? v : '';
    }
    function prefillEmail() {
      var el = panel && panel.querySelector('[data-lpill-email]');
      if (!el || el.value) return;
      var v = rememberedEmail();
      if (v) el.value = v;
    }
    function loginUrl(email, back) {
      return '/customer_authentication/login?login_hint=' + encodeURIComponent(email) + '&return_to=' + encodeURIComponent(back);
    }
    function backUrl() { return location.pathname + location.search; }
    function signIn(email) {
      try { sessionStorage.setItem(JOIN_KEY, '1'); } catch (e) {}
      notePromise();
      location.href = loginUrl(email, backUrl());
    }
    /* Desktop only: phones turn window.open into a new tab, which is worse
       than the redirect. Must be called straight from the click so pop-up
       blockers allow it. Returns the window, or null to fall back. */
    function desktop() {
      try { return window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 768; } catch (e) { return false; }
    }
    function openLoginWindow(email) {
      if (!desktop()) return null;
      var back = backUrl();
      var ret = back + (back.indexOf('?') > -1 ? '&' : '?') + 'sc_lpill=signed-in';
      var w = 480, h = 720;
      var left = Math.max(0, Math.round((window.screenX || 0) + ((window.outerWidth || w) - w) / 2));
      var top = Math.max(0, Math.round((window.screenY || 0) + ((window.outerHeight || h) - h) / 2));
      var win = null;
      try {
        win = window.open(loginUrl(email, ret), 'sc-lpill-login', 'popup=yes,width=' + w + ',height=' + h + ',left=' + left + ',top=' + top + ',resizable=yes,scrollbars=yes');
      } catch (e) { win = null; }
      if (!win) return null;
      try { sessionStorage.setItem(JOIN_KEY, '1'); } catch (e) {}
      notePromise();
      try { win.focus(); } catch (e) {}
      return win;
    }
    /* Watch the sign-in window. Done when it posts back, or when it lands
       on our return URL, or (belt and braces) when it closes and this page
       turns out to be signed in. Otherwise put the panel back as it was. */
    var loginWin = null, loginTimer = null, loginDone = false;
    function finishLogin() {
      if (loginDone) return;
      loginDone = true;
      clearInterval(loginTimer);
      try { if (loginWin && !loginWin.closed) loginWin.close(); } catch (e) {}
      track('popup_signed_in');
      var cta = panel.querySelector('[data-lpill-cta]');
      if (cta) cta.textContent = fill(cfg.text.signingIn);
      location.reload();
    }
    /* Sign in with Shop completes in its own window and leaves this page as it was, so the
       pill would still read as a guest. Once the button has been used (a tap, the button
       changing or vanishing, or focus coming back from the Shop window) ask the page whether
       the customer is signed in now, and reload when they are. */
    var shopWatch = 0, shopWatchUntil = 0;
    /* Shopify's button sizes itself. Ask for the full width before its module loads, then
       hand it the measured width in pixels whenever the panel is shown or resized. */
    (function () {
      var el = document.querySelector('[data-lpill-shop] shop-login-button');
      if (el && !el.hasAttribute('full-width')) el.setAttribute('full-width', '');
    })();
    function sizeShopBtn() {
      var wrap = panel && panel.querySelector('[data-lpill-shop]');
      var el = wrap && !wrap.hidden && wrap.querySelector('shop-login-button');
      if (!el) return;
      var w = Math.round(wrap.getBoundingClientRect().width);
      if (w > 0) el.style.setProperty('--shop-pay-button-width', w + 'px');
    }
    function finishShopLogin() {
      clearInterval(shopWatch); shopWatch = 0;
      try { sessionStorage.setItem(JOIN_KEY, '1'); } catch (e) {}
      notePromise();
      track('shop_signed_in');
      var cta = panel.querySelector('[data-lpill-cta]');
      if (cta) { cta.textContent = fill(cfg.text.signingIn); cta.disabled = true; }
      location.reload();
    }
    function watchShopSignIn() {
      shopWatchUntil = Date.now() + 180000;
      if (shopWatch) return;
      shopWatch = setInterval(function () {
        if (Date.now() > shopWatchUntil) { clearInterval(shopWatch); shopWatch = 0; return; }
        probeMember().then(function (member) { if (member) finishShopLogin(); });
      }, 2000);
    }
    function armShopWatch() {
      var wrap = panel && panel.querySelector('[data-lpill-shop]');
      if (!wrap || wrap.__scArmed) return;
      wrap.__scArmed = true;
      sizeShopBtn();
      if (window.ResizeObserver) new ResizeObserver(sizeShopBtn).observe(wrap); else window.addEventListener('resize', sizeShopBtn);
      if (window.MutationObserver) new MutationObserver(function () { if (!wrap.hidden) watchShopSignIn(); }).observe(wrap, { childList: true, subtree: true, attributes: true });
      window.addEventListener('focus', function () { if (!wrap.hidden && !panel.hidden) probeMember().then(function (member) { if (member) finishShopLogin(); }); });
    }
    function probeMember() {
      return fetch(backUrl(), { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = /id="LoyaltyPillConfig"[^>]*>([\s\S]*?)<\/script>/.exec(html);
          if (!m) return false;
          try { return !!JSON.parse(m[1]).member; } catch (e) { return false; }
        }).catch(function () { return false; });
    }
    function restoreAfterPopup() {
      clearInterval(loginTimer);
      loginWin = null;
      var cta = panel.querySelector('[data-lpill-cta]');
      if (cta) cta.disabled = false;
      var emailEl = panel.querySelector('[data-lpill-email]');
      var typed = emailEl ? emailEl.value : '';
      buildPanel();
      if (emailEl) emailEl.value = typed;
      try { sessionStorage.removeItem(JOIN_KEY); } catch (e) {}
    }
    function watchLoginWindow(win, email) {
      loginWin = win; loginDone = false;
      var cta = panel.querySelector('[data-lpill-cta]');
      cta.disabled = true;
      cta.textContent = fill(cfg.text.waiting);
      var note = panel.querySelector('[data-lpill-note]');
      if (note) {
        note.textContent = fill(cfg.text.waitingHelp) + ' ';
        var a = document.createElement('a');
        a.href = loginUrl(email, backUrl());
        a.textContent = fill(cfg.text.waitingLink);
        a.addEventListener('click', function () { track('popup_fallback'); try { sessionStorage.setItem(JOIN_KEY, '1'); } catch (e) {} notePromise(); });
        note.appendChild(a);
        note.hidden = false;
      }
      track('popup_open');
      loginTimer = setInterval(function () {
        if (loginDone) return;
        var closed = true;
        try { closed = !win || win.closed; } catch (e) {}
        if (!closed) {
          /* Same-origin again once Shopify has sent it back to us. */
          try { if (/[?&]sc_lpill=signed-in/.test(win.location.search)) { finishLogin(); } } catch (e) {}
          return;
        }
        clearInterval(loginTimer);
        probeMember().then(function (member) {
          if (member) finishLogin();
          else { track('popup_closed'); restoreAfterPopup(); }
        });
      }, 500);
    }
    window.addEventListener('message', function (e) {
      if (e.origin !== location.origin || !e.data || e.data.scLpill !== 'signed-in') return;
      if (e.data.member) finishLogin();
      else { track('popup_closed'); restoreAfterPopup(); }
    });
    /* ---------- two quick questions ---------- */
    var PROFILE_KEY = 'sc-lpill-profile-' + cfg.customerId;
    var profileStep = 0;
    var profileAnswers = { type: '', concerns: [] };
    var profileEdit = false;
    /* The answers on the customer record (written through the bridge), so
       they are known on every device and can be shown in the account drawer. */
    var current = (function () {
      var c = (cfg.profile && cfg.profile.current) || {};
      var cs = c.concerns;
      if (!Array.isArray(cs)) cs = cs ? String(cs).split(',').map(function (x) { return x.trim(); }).filter(Boolean) : [];
      var out = { type: c.type ? String(c.type) : '', concerns: cs };
      /* Straight after the questions, For you can load before the bridge has written the answers to the
         record: use the ones handed over (sessionStorage sc-foryou, which assets/sc-skin.js reads after this),
         so "Update your answers" opens with them ticked. */
      if (!out.type && !out.concerns.length && cfg.forYou && location.pathname === cfg.forYou) {
        try {
          var h = JSON.parse(sessionStorage.getItem('sc-foryou') || 'null');
          if (h && Date.now() - Number(h.t || 0) < 30 * 60 * 1000) {
            out.type = h.type ? String(h.type) : '';
            out.concerns = Array.isArray(h.concerns) ? h.concerns.map(String).filter(Boolean) : [];
          }
        } catch (e) {}
      }
      return out;
    })();
    function profileWanted() {
      var pr = cfg.profile;
      if (!cfg.member || !pr || !pr.enabled || !cfg.email || !cfg.klaviyoKey) return false;
      if (!pr.types.some(function (o) { return o.label; })) return false;
      if (current.type || current.concerns.length) return false;
      try { if (localStorage.getItem(PROFILE_KEY) === '1') return false; } catch (e) {}
      return true;
    }
    function startProfile() {
      editFrom = '';
      profileEdit = false;
      profileStep = 1;
      profileAnswers = { type: '', concerns: [] };
      openPanel('profile');
    }
    /* The same questions again, filled in, to change the answers later. Opened from the
       picks themselves ({from: 'picks'}), it closes after saving: the picks refresh behind it. */
    var editFrom = '';
    function startProfileEdit(opts) {
      if (!cfg.member || !cfg.profile || !cfg.profile.enabled) return false;
      cancelForYou();
      editFrom = (opts && opts.from) || '';
      profileEdit = true;
      profileStep = 1;
      profileAnswers = { type: current.type, concerns: current.concerns.slice() };
      editForPoints = profileStale();
      openPanel('profile');
      return true;
    }
    /* Points for the answers are on when the amount in Theme settings is above 0. */
    function pointsOn() { return !!(cfg.profile && cfg.profile.enabled && Number(cfg.profile.points) > 0); }
    /* Answers older than the months in Theme settings earn points again when updated. */
    function profileStale() {
      if (!pointsOn() || !cfg.member || !(current.type || current.concerns.length)) return false;
      var months = Number(cfg.profile.refreshMonths) || 0;
      var at = cfg.profile.updatedAt ? Date.parse(cfg.profile.updatedAt) : NaN;
      if (!months || isNaN(at)) return false;
      return Date.now() - at > months * 30.44 * 86400000;
    }
    var editForPoints = false;
    var pointsDue = false;
    /* What every profile write carries: who they are and where they shop,
       so Klaviyo can segment by country, market, currency and language
       without waiting for an address. Klaviyo's own Location field is left
       to its Shopify sync. */
    function profileBase(email) {
      var attrs = { email: email || cfg.email, properties: {} };
      if (cfg.firstName && !email) attrs.first_name = cfg.firstName;
      if (cfg.storeCountry) attrs.properties['Store Country'] = cfg.storeCountry;
      if (cfg.country) attrs.properties['Store Country Code'] = cfg.country;
      if (cfg.market) attrs.properties['Store Market'] = cfg.market;
      if (cfg.currency) attrs.properties['Store Currency'] = cfg.currency;
      if (cfg.storeLanguage) attrs.properties['Store Language'] = cfg.storeLanguage;
      return attrs;
    }
    function postProfile(body) {
      return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(cfg.klaviyoKey), {
        method: 'POST',
        keepalive: true,
        headers: { 'content-type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); });
    }
    function sendProfile() {
      var pr = cfg.profile;
      var attrs = profileBase();
      if (profileAnswers.type) attrs.properties[pr.propType] = profileAnswers.type;
      /* The latest explicit choice replaces what was there, so edits take effect. */
      if (profileAnswers.concerns.length || profileEdit) attrs.properties[pr.propConcerns] = profileAnswers.concerns;
      /* When they answered, so Klaviyo can ask again in a few months. */
      if (profileAnswers.type || profileAnswers.concerns.length) attrs.properties[pr.propUpdated || 'Skin Profile Updated At'] = new Date().toISOString();
      return postProfile({ data: { type: 'profile', attributes: attrs } });
    }
    /* The same answers on the Shopify customer record (through the bridge), so every device and the account drawer can show them. */
    function storeProfile() {
      if (!cfg.bridgeUrl || !cfg.bridgeSig || !cfg.email) return Promise.resolve();
      return fetch(cfg.bridgeUrl.replace(/\/code\/?$/, '/profile'), {
        method: 'POST',
        keepalive: true,
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ customerId: String(cfg.customerId), email: cfg.email, sig: cfg.bridgeSig, skinType: profileAnswers.type, skinConcerns: profileAnswers.concerns })
      }).then(function (r) {
        if (!r.ok) throw new Error('bridge ' + r.status);
        return r.json().catch(function () { return {}; });
      }).then(function (d) {
        /* The bridge may still flag points as due while the Worker's SKIN_POINTS_DAYS is above 0; with the amount at 0 in Theme settings nothing is said about points. */
        if (d && d.pointsDue && pointsOn()) { pointsDue = true; track('profile_points'); }
        return d || {};
      });
    }
    function rememberProfile() {
      current = { type: profileAnswers.type, concerns: profileAnswers.concerns.slice() };
      if (cfg.profile && (current.type || current.concerns.length)) cfg.profile.updatedAt = new Date().toISOString();
      try { localStorage.setItem(PROFILE_KEY, '1'); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('sc:profile', { detail: { type: current.type, concerns: current.concerns.slice() } })); } catch (e) {}
    }
    /* Country and the rest still go through when the questions are skipped, and at email sign-up. */
    function sendBase(email) {
      if (!(email || cfg.email) || !cfg.klaviyoKey) return;
      try { postProfile({ data: { type: 'profile', attributes: profileBase(email) } }).catch(function () {}); } catch (e) {}
    }
    function finishProfile(cta) {
      var answered = profileAnswers.type || profileAnswers.concerns.length;
      var wasEdit = profileEdit;
      track(wasEdit ? 'profile_edit' : 'profile_done', { lp_type: profileAnswers.type, lp_concerns: profileAnswers.concerns.join(', ') });
      rememberProfile();
      stopProfileNudge();
      pointsDue = false;
      var sent = withTimeout(Promise.all([sendProfile(), storeProfile().catch(function () { track('profile_store_error'); })]), 8000);
      sent.then(null, function () { track('profile_error'); });
      profileEdit = false;
      editForPoints = false;
      if (joinFlow && !wasEdit) {
        profileDone = true;
        if (answered) answeredInJoin = true;
        openPanel('welcome');
        goForYou();
        /* The card is open already; the points note joins it once the bridge has answered. */
        sent.then(function () { if (pointsDue) refreshPanel(); }, function () {});
        return;
      }
      if (!answered && !wasEdit) { closePanel(); return; }
      var thanks = function () {
        accentTitle(fill(pointsDue ? cfg.profile.pointsThanks : (wasEdit ? cfg.profile.saved : cfg.profile.thanks)), '');
        panel.querySelector('[data-lpill-lede]').hidden = true;
        panel.querySelector('[data-lpill-opts]').hidden = true;
        panel.querySelector('[data-lpill-skip]').hidden = true;
        cta.hidden = true;
        var picks = panel.querySelector('[data-lpill-picks]');
        /* With picks to look at, the card stays until they choose; opened from the picks, it just closes. */
        if (picks && answered && editFrom !== 'picks') { picks.hidden = false; return; }
        editFrom = '';
        setTimeout(closePanel, wasEdit ? 1500 : 2000);
      };
      sent.then(thanks, thanks);
    }
    function onSubmit(e) {
      e.preventDefault();
      var cta = panel.querySelector('[data-lpill-cta]');
      if (cta.disabled) return;
      sayError('');
      if (mode === 'welcome') {
        if (cfg.offerEligible && !offerApplied && cfg.offerCode && bridgeState !== 'used') { cancelForYou(); track('offer_apply', { lp_from: 'welcome' }); location.href = offerUrl(); return; }
        if (cfg.offerEligible && !offerApplied && !cfg.offerCode && needsEmail() && bridgeState !== 'used' && bridgeState !== 'ineligible') { track('welcome_email'); openPanel('member'); return; }
        track('welcome_close');
        if (profileWanted()) { startProfile(); return; }
        closePanel(); return;
      }
      if (mode === 'profile') {
        var picked = [].slice.call(panel.querySelectorAll('[data-lpill-opts] input:checked')).map(function (i) { return i.value; });
        if (profileStep === 1) {
          profileAnswers.type = picked[0] || '';
          track('profile_type', { lp_value: profileAnswers.type });
          profileStep = 2;
          buildPanel();
          setTimeout(function () { var f = panel.querySelector('[data-lpill-opts] input'); if (f) f.focus(); }, 30);
          return;
        }
        profileAnswers.concerns = picked;
        cta.disabled = true;
        finishProfile(cta);
        return;
      }
      if (mode === 'member') {
        cta.disabled = true;
        withTimeout(subscribe(cfg.email), 8000).then(function () {
          track('consent_given');
          leadToElevar(cfg.email);
          stopNudge();
          /* Klaviyo sends the welcome email within a minute of the sign-up and assigns the code as it does; start asking the bridge after a short pause. */
          if (cfg.offerEligible && !offerApplied && !cfg.offerCode) {
            bridgeTries = 0; joinSession = true;
            try { sessionStorage.setItem(JOINED_KEY, String(Date.now())); } catch (e) {}
            setTimeout(askBridge, 4000);
          }
          accentTitle(fill(cfg.text.memberThanks), '');
          panel.querySelector('[data-lpill-lede]').hidden = true;
          cta.hidden = true;
          if (profileWanted()) { setTimeout(startProfile, 1500); return; }
          setTimeout(function () { if (cfg.offerEligible && !offerApplied) openPanel('welcome'); else closePanel(); }, 2600);
        }, function () {
          track('consent_error');
          sayError(cfg.text.failed);
          cta.disabled = false;
        });
        return;
      }
      var emailEl = panel.querySelector('[data-lpill-email]');
      var email = (emailEl.value || '').trim();
      if (!validEmail(email)) { sayError(cfg.text.badEmail); emailEl.focus(); return; }
      try { localStorage.setItem(EMAIL_KEY, email); } catch (e) {}
      var consent = panel.querySelector('[data-lpill-consent]');
      var consentLine = panel.querySelector('[data-lpill-consent-line]');
      /* With no tick box, the email entered for the offer is the sign-up, as the line beside it says. */
      var ticked = (cfg.consentMode === 'implied' && !!consentLine && !consentLine.hidden) || !!(consent && consent.checked && !consent.closest('[hidden]'));
      cta.disabled = true;
      track('cta', { lp_consent: ticked });
      var win = openLoginWindow(email);
      if (win) {
        /* The page stays, so consent can go through in the background. */
        if (ticked) withTimeout(subscribe(email), 8000).then(function () { track('consent_given'); leadToElevar(email); }, function () { track('consent_error'); });
        watchLoginWindow(win, email);
        return;
      }
      if (ticked) {
        /* Never hold up the sign-in for long: if Klaviyo is slow or fails,
           the member nudge will simply ask again once they are signed in. */
        withTimeout(subscribe(email), 2500).then(function () { track('consent_given'); leadToElevar(email); }, function () { track('consent_error'); })
          .then(function () { signIn(email); });
      } else {
        signIn(email);
      }
    }
    var lastFocus = null;
    function openPanel(m) {
      if (!panel) return;
      var auto = autoOpening;
      /* Any other opening is the shopper's own doing: it is no longer the panel that opened by itself, and it will not open by itself this visit. */
      if (!auto) {
        autoShowing = false;
        try { sessionStorage.setItem(OPENED_KEY, '1'); } catch (e) {}
      }
      if (typeof m === 'string') mode = m;
      panel.setAttribute('data-mode', mode);
      /* The code card with no code in hand yet: ask the bridge again (it keeps asking while the card is open). */
      if (mode === 'welcome' && cfg.offerEligible && !offerApplied && !cfg.offerCode && !needsEmail() && !bridgeBusy() && bridgeState !== 'used' && bridgeState !== 'ineligible') { bridgeTries = 0; askBridge(); }
      var ctaEl = panel.querySelector('[data-lpill-cta]');
      ctaEl.hidden = false;
      ctaEl.disabled = false;
      buildPanel();
      lastFocus = document.activeElement;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var card = panel.querySelector('.lpill-panel__card');
      /* Opened by itself: focus the card, not the email box, so no keyboard springs up on a phone. */
      setTimeout(function () { (auto ? card : (panel.querySelector('[data-lpill-email]') || panel.querySelector('[data-lpill-cta]') || card)).focus(); }, 30);
      var ex = { lp_mode: mode, lp_step: profileStep };
      if (auto) ex.lp_auto = 1;
      track(mode === 'member' ? 'consent_open' : (mode === 'welcome' ? 'welcome' : (mode === 'profile' ? 'profile_open' : 'open')), ex);
    }
    function closePanel() {
      autoShowing = false;
      if (!panel || panel.hidden) return;
      if (mode === 'welcome') joinFlow = false;
      panel.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (panel) {
      panel.addEventListener('click', function (e) {
        if (e.target.closest('[data-lpill-close]')) closePanel();
        var copy = e.target.closest('[data-lpill-coupon-copy]');
        if (copy) copyCode(copy);
        var earnEl = e.target.closest('[data-lpill-earn]');
        if (earnEl) {
          track('welcome_earn');
          /* Open Rivo's drawer on its ways-to-earn screen right here; only go to the page if no drawer appears. */
          if (cfg.earnHash && (window.RivoJS || document.querySelector('.rivo-slideout__container'))) {
            e.preventDefault();
            var fallback = earnEl.getAttribute('href');
            closePanel();
            try { location.hash = cfg.earnHash; } catch (err) {}
            setTimeout(function () { if (!drawerVisible() && fallback) location.href = fallback; }, 900);
          }
        }
        if (e.target.closest('[data-lpill-coupon-terms]')) track('offer_terms');
        if (e.target.closest('[data-lpill-shop]')) {
          track('shop_signin');
          try { sessionStorage.setItem(JOIN_KEY, '1'); } catch (err) {}
          notePromise();
          watchShopSignIn();
        }
      });
      panel.querySelector('[data-lpill-skip]').addEventListener('click', function () {
        try { localStorage.setItem(PROFILE_KEY, '1'); } catch (e) {}
        stopProfileNudge();
        track('profile_skip', { lp_step: profileStep });
        sendBase();
        if (joinFlow) { profileDone = true; openPanel('welcome'); return; }
        closePanel();
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closePanel(); return; }
        if (e.key !== 'Tab') return;
        var f = panel.querySelectorAll('a[href],button:not([disabled]):not([hidden]),input');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      panel.querySelector('[data-lpill-form]').addEventListener('submit', onSubmit);
      /* Once they touch or type in a panel that opened by itself, it is theirs: a Klaviyo pop-up arriving later no longer closes it. */
      ['pointerdown', 'keydown', 'input'].forEach(function (t) { panel.addEventListener(t, function () { autoShowing = false; }, true); });
    }
    /* A tap on the minimised icon only restores the pill. */
    try { if (sessionStorage.getItem(MIN_KEY) === '1') root.classList.add('is-min'); } catch (e) {}
    btn.addEventListener('click', function (e) {
      if (!root.classList.contains('is-min')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      root.classList.remove('is-min');
      try { sessionStorage.removeItem(MIN_KEY); } catch (e2) {}
      track('restore');
    }, true);
    if (btn.tagName === 'BUTTON') btn.addEventListener('click', function () { openPanel(state === 'known' ? 'known' : 'guest'); });
    else btn.addEventListener('click', function (e) {
      if (!showingNudge && cfg.offerEligible && !offerApplied) {
        if (!cfg.offerCode || bridgeState === 'used') {
          /* No code to apply yet: open the panel that explains what happens next. */
          e.preventDefault();
          e.stopImmediatePropagation();
          openPanel(needsEmail() && bridgeState !== 'used' && bridgeState !== 'ineligible' ? 'member' : 'welcome');
          return;
        }
        track('offer_apply', { lp_from: 'pill' });
        return;
      }
      if (!showingNudge && cfg.offerEligible && offerApplied && cfg.offerCode) {
        /* The code card again: copy the code, or see that it is on the bag. */
        e.preventDefault();
        e.stopImmediatePropagation();
        track('offer_view');
        openPanel('welcome');
        return;
      }
      if (showingNudge) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var kind = nudgeKindNow;
        clearInterval(nudgeTimer);
        nudgeTimer = 0;
        showingNudge = false;
        nudgeKindNow = '';
        render();
        if (kind === 'profile' || kind === 'refresh') {
          try { sessionStorage.setItem(PNUDGED_KEY, '1'); } catch (e2) {}
          track(kind + '_nudge_tap');
          if (kind === 'profile') startProfile(); else startProfileEdit();
          return;
        }
        try { sessionStorage.setItem(NUDGED_KEY, '1'); } catch (e2) {}
        openPanel('member');
        return;
      }
      track('cta');
    }, true);

    /* ---------- states ---------- */
    var SEEN_KEY = 'sc-lpill-seen-member';
    function guest() {
      var remembered = false;
      try { remembered = localStorage.getItem(SEEN_KEY) === '1'; } catch (e) {}
      if (remembered) { state = 'known'; setText(fill(cfg.text.known)); return; }
      setText(fill(cfg.offer ? cfg.text.guestOffer : cfg.text.guest));
      try {
        var k = window.klaviyo;
        if (k && typeof k.isIdentified === 'function') {
          Promise.resolve(k.isIdentified()).then(function (known) {
            if (known && state === 'guest') { state = 'known'; setText(fill(cfg.text.known)); }
          }).catch(function () {});
        }
      } catch (e) {}
    }
    var PTS_KEY = 'sc-lpill-pts-' + cfg.customerId;
    var NUDGED_KEY = 'sc-lpill-nudged';
    var OFFER_KEY = 'sc-lpill-offer-' + cfg.customerId;
    var pointsLine = '';
    var lastPoints = null;
    var showingNudge = false;
    var offerApplied = !!cfg.offerApplied;
    try { if (!offerApplied && localStorage.getItem(OFFER_KEY) === '1') offerApplied = true; } catch (e) {}
    /* The code is new on this page (not on their record, not on the bag): the move to For you is for that
       first time, not every sign-in. Answers given in this join count too (answeredInJoin). */
    var codeNewHere = !offerApplied && !cfg.offerCode;
    function offerUrl() {
      return '/discount/' + encodeURIComponent(cfg.offerCode) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
    }
    /* ---------- the first-order code ----------
       The code is the customer's own Klaviyo welcome code (coupon CUPID), the
       one the welcome email carries. Klaviyo assigns it when that email sends,
       so it only exists once they have joined the emails. The welcome code
       bridge (Theme settings > Loyalty pill) reads it back from Klaviyo, checks
       it is unused in Shopify and stores it on the customer, so Liquid has it
       on later visits without asking again.
       Shopify's /discount/<code> link puts the code on the bag and redirects.
       Fetched quietly it still sets the cookie, so a new member sees the
       offer applied without leaving the page. Shopify checks eligibility at
       checkout (one use per code), and we only apply it when Liquid says this
       customer has no orders. */
    var bridgeState = '';
    var bridgeTries = 0;
    var bridgeTimer = 0;
    var bridgeInFlight = false;
    var applyInFlight = false;
    /* joinPage: this is the first page after sign-in. joinSession: within ten
       minutes of joining or consenting, on any page, so a code that lands a
       little late is still picked up while they browse. */
    var JOINED_KEY = 'sc-lpill-joined';
    var joinPage = false;
    var joinSession = false;
    try {
      joinPage = sessionStorage.getItem(JOIN_KEY) === '1';
      var joinedAt = Number(sessionStorage.getItem(JOINED_KEY) || 0);
      if (joinPage) { joinedAt = Date.now(); sessionStorage.setItem(JOINED_KEY, String(joinedAt)); }
      joinSession = joinedAt > 0 && Date.now() - joinedAt < 10 * 60 * 1000;
    } catch (e) {}
    /* True while a bridge call, a retry or the quiet apply is still to come. */
    function bridgeBusy() { return bridgeInFlight || applyInFlight || !!bridgeTimer; }
    function settle() { if (!bridgeBusy()) welcomeGate('bridge'); }
    function refreshPanel() { if (panel && !panel.hidden && mode === 'welcome') buildPanel(); }
    function needsEmail() {
      if (cfg.subscribed) return false;
      try { if (localStorage.getItem(SUB_KEY) === '1') return false; } catch (e) {}
      return true;
    }
    function askBridge() {
      if (bridgeTimer) { clearTimeout(bridgeTimer); bridgeTimer = 0; }
      if (!cfg.bridgeUrl || !cfg.bridgeSig || !cfg.email || cfg.offerCode || !cfg.offerEligible || offerApplied) { settle(); return; }
      bridgeInFlight = true;
      fetch(cfg.bridgeUrl, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ customerId: String(cfg.customerId), email: cfg.email, sig: cfg.bridgeSig })
      }).then(function (r) { return r.json(); }).then(function (d) {
        bridgeInFlight = false;
        var st = d && d.status ? String(d.status) : 'error';
        if (st === 'ok' && d.code) {
          cfg.offerCode = String(d.code).toUpperCase();
          bridgeState = 'ok';
          track('offer_code', { lp_from: 'bridge' });
          applyCode();
          return;
        }
        bridgeState = st;
        track('offer_' + st);
        /* Still waiting for Klaviyo: keep asking, every 6s for a minute on the page they land on after
           joining, then every 15s for a minute per page while the join window or the open card lasts. */
        var limit = joinPage ? 10 : (forYouWaiting ? 40 : 4);
        if (st === 'pending' && !needsEmail() && (joinSession || forYouWaiting || !panel.hidden) && bridgeTries < limit) {
          bridgeTries++;
          bridgeTimer = setTimeout(askBridge, joinPage ? 6000 : 15000);
        }
        codeState(bridgeTimer ? 'pending' : 'none');
        render();
        refreshPanel();
        settle();
      }).catch(function () { bridgeInFlight = false; bridgeState = 'error'; codeState('none'); render(); refreshPanel(); settle(); });
    }
    function applyCode() {
      if (!cfg.offerEligible || offerApplied || !cfg.offerCode) { settle(); return; }
      applyInFlight = true;
      /* Shopify answers the discount link with a redirect that carries the cookie. Not following it means nothing is downloaded. */
      fetch(offerUrl(), { credentials: 'same-origin', redirect: 'manual' }).then(function (r) {
        if (!(r.ok || r.type === 'opaqueredirect')) throw new Error('discount');
        offerApplied = true;
        try { localStorage.setItem(OFFER_KEY, '1'); } catch (e) {}
        track('offer_applied', { lp_from: 'auto' });
      }).catch(function () {}).then(function () { applyInFlight = false; render(); refreshPanel(); settle(); announceCode(); goForYou(); });
    }
    /* ---------- on to For you ----------
       "Automatically" (Theme settings > Loyalty pill > Getting to For you): from the code card in
       the join flow, a new member with skin answers goes to the For you collection once their code
       is on the bag, or once the wait set there has passed with the code still on its way (Klaviyo
       can take minutes; the code is put on the bag on the For you page when it lands). Through the
       /discount/ link when the quiet apply did not take. Closing the card stops it. */
    var FORYOU_KEY = 'sc-foryou';
    var FORYOU_WAIT_KEY = 'sc-foryou-wait';
    var answeredInJoin = false;
    var forYouTimer = 0;
    var forYouWaitTimer = 0;
    var forYouDeadline = 0;
    var forYouGone = false;
    var onForYou = !!cfg.forYou && location.pathname === cfg.forYou;
    /* Sent here to wait for a code still on its way: the pill keeps asking for it on this page. */
    var forYouWaiting = false;
    try { forYouWaiting = onForYou && Date.now() - Number(sessionStorage.getItem(FORYOU_WAIT_KEY) || 0) < 15 * 60 * 1000; } catch (e) {}
    function handOver() {
      try {
        sessionStorage.setItem(FORYOU_KEY, JSON.stringify({ type: current.type, concerns: current.concerns.slice(), t: Date.now() }));
        if (cfg.offerEligible && !offerApplied && !needsEmail() && bridgeState !== 'used') sessionStorage.setItem(FORYOU_WAIT_KEY, String(Date.now()));
      } catch (e) {}
    }
    /* They chose something else (a link on the card, applying the code from its button, an edit, another page): no move. */
    function cancelForYou() {
      forYouGone = true;
      clearTimeout(forYouTimer);
      forYouTimer = 0;
      clearTimeout(forYouWaitTimer);
      forYouWaitTimer = 0;
    }
    function forYouDue() {
      if (!cfg.forYou || cfg.forYouMode !== 'auto' || forYouGone || !joinFlow || onForYou) return false;
      if (!(current.type || current.concerns.length)) return false;
      if (!answeredInJoin && !codeNewHere) return false;
      if (!cfg.offerEligible || bridgeState === 'used' || bridgeState === 'ineligible' || applyInFlight) return false;
      /* Without email consent there is no code coming: the card asks them to join the emails instead. */
      return !(!cfg.offerCode && needsEmail());
    }
    function goForYou() {
      if (forYouTimer || !forYouDue()) return;
      var ready = offerApplied || (!!cfg.offerCode && !bridgeBusy());
      /* Waiting only makes sense while a code can still arrive: not after a bridge error. */
      if (!ready && !bridgeBusy() && bridgeState !== 'pending') return;
      if (!ready) {
        if (!forYouDeadline) forYouDeadline = Date.now() + Math.max(0, Number(cfg.forYouWait) || 0) * 1000;
        var left = forYouDeadline - Date.now();
        if (left > 0) {
          clearTimeout(forYouWaitTimer);
          forYouWaitTimer = setTimeout(function () { forYouWaitTimer = 0; goForYou(); }, left);
          return;
        }
      }
      clearTimeout(forYouWaitTimer);
      forYouWaitTimer = 0;
      forYouTimer = setTimeout(function () {
        forYouTimer = 0;
        if (!forYouDue() || !panel || panel.hidden || mode !== 'welcome' || profileEdit || rivoOpen() || drawerVisible()) return;
        forYouGone = true;
        handOver();
        var viaLink = !offerApplied && !!cfg.offerCode && !bridgeBusy();
        track('foryou_redirect', { lp_from: offerApplied ? 'applied' : (viaLink ? 'discount_link' : 'waited') });
        location.href = viaLink ? '/discount/' + encodeURIComponent(cfg.offerCode) + '?redirect=' + encodeURIComponent(cfg.forYou) : cfg.forYou;
      }, ready ? 1500 : 0);
    }
    window.addEventListener('pagehide', cancelForYou);
    /* "See picks for your skin" goes to For you when there is one: the answers go with it. */
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;
      if (target.closest('[data-lpill-foryou]')) {
        cancelForYou();
        handOver();
        track('foryou_click');
        return;
      }
      /* A link on the card (terms, rewards, earn, more) is somewhere they chose to go. The card's own buttons
         (Next, Done, Skip, Copy) are the flow itself; closing the card is caught when the timer fires. */
      if (panel && panel.contains(target) && target.closest('a[href]')) cancelForYou();
    }, true);
    /* The For you page shows the code once it lands (sections/sc-for-you.liquid). */
    function announceCode() {
      if (!cfg.offerCode) return;
      try { document.dispatchEvent(new CustomEvent('sc:welcome-code', { detail: { code: cfg.offerCode, applied: offerApplied } })); } catch (e) {}
    }
    /* Whether a code is still being fetched on this page ('pending') or not ('none'), for the For you line. */
    function codeState(s) {
      if (!onForYou) return;
      try { document.dispatchEvent(new CustomEvent('sc:welcome-code-state', { detail: { state: s } })); } catch (e) {}
    }
    /* Applied on an earlier visit: put it back on the bag quietly once a session, in case the cookie has gone. */
    var REAPPLY_KEY = 'sc-lpill-reapplied';
    function reapply() {
      try { if (sessionStorage.getItem(REAPPLY_KEY) === '1') return; sessionStorage.setItem(REAPPLY_KEY, '1'); } catch (e) { return; }
      fetch(offerUrl(), { credentials: 'same-origin', redirect: 'manual' }).catch(function () {});
    }
    function applyOffer() {
      if (!cfg.offerEligible || offerApplied) {
        if (cfg.offerEligible && offerApplied && cfg.offerCode && !cfg.offerApplied) reapply();
        return;
      }
      if (cfg.offerCode) { applyCode(); return; }
      if (needsEmail()) return;
      askBridge();
    }

    /* ---------- the code card ---------- */
    function renderCoupon(st) {
      var box = panel && panel.querySelector('[data-lpill-coupon]');
      if (!box) return;
      if (!st) { box.hidden = true; return; }
      box.hidden = false;
      box.setAttribute('data-coupon', st);
      box.querySelector('[data-lpill-coupon-label]').textContent = fill(cfg.text.couponLabel);
      var codeEl = box.querySelector('[data-lpill-coupon-code]');
      var copy = box.querySelector('[data-lpill-coupon-copy]');
      if (st === 'finding') {
        codeEl.textContent = fill(cfg.text.couponFinding);
        copy.hidden = true;
      } else {
        codeEl.textContent = cfg.offerCode;
        copy.hidden = false;
        copy.textContent = fill(cfg.text.couponCopy);
        copy.setAttribute('aria-label', fill(cfg.text.couponCopy) + ' ' + cfg.offerCode);
      }
      box.querySelector('[data-lpill-coupon-status]').textContent = fill(st === 'applied' ? cfg.text.couponApplied : (st === 'ready' ? cfg.text.couponReady : cfg.text.couponFindingNote));
    }
    function legacyCopy(text) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      return ok;
    }
    function copyCode(button) {
      if (!cfg.offerCode) return;
      var done = function (ok) {
        button.textContent = fill(ok ? cfg.text.couponCopied : cfg.text.couponCopy);
        if (!ok) return;
        track('offer_copy');
        setTimeout(function () { button.textContent = fill(cfg.text.couponCopy); }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(cfg.offerCode).then(function () { done(true); }, function () { done(legacyCopy(cfg.offerCode)); });
      } else {
        done(legacyCopy(cfg.offerCode));
      }
    }
    function render() {
      if (showingNudge) { setText(nudgeText()); return; }
      if (cfg.offerEligible && !offerApplied) {
        if (cfg.offerCode && bridgeState !== 'used') {
          setText(fill(cfg.text.offerReady));
          if (btn.tagName === 'A') btn.href = offerUrl();
          return;
        }
        if (btn.tagName === 'A') btn.href = cfg.accountUrl;
        if (bridgeState === 'used' || bridgeState === 'ineligible') { setText(pointsLine); return; }
        setText(fill(needsEmail() ? cfg.text.consentOffer : cfg.text.offerPending));
        return;
      }
      if (btn.tagName === 'A') btn.href = cfg.accountUrl;
      if (cfg.offerEligible && offerApplied && lastPoints != null) {
        /* "0 points" reads like a mistake while Rivo is still crediting the joining points. */
        setText(lastPoints > 0 ? fill(cfg.text.offerApplied, { points: lastPoints }) : fill(cfg.text.offerAppliedNoPoints));
        return;
      }
      setText(pointsLine);
    }
    function showPoints(pts) {
      lastPoints = pts;
      if (pts >= cfg.minRedeem) {
        var spendable = Math.min(Math.floor(pts / cfg.pointsPerUnit) * cfg.pointsPerUnit, cfg.maxRedeem);
        pointsLine = fill(cfg.text.member, { points: pts, value: spendable / cfg.pointsPerUnit });
        root.setAttribute('data-ready', '1');
      } else {
        pointsLine = fill(cfg.text.memberLow, { points: pts, toReward: cfg.minRedeem - pts });
        root.removeAttribute('data-ready');
      }
      render();
      startNudge();
      welcomeGate('points');
    }
    /* ---------- the hello after sign-in ----------
       Waits for the joining points (up to 4s) and, when there are no
       questions to ask first, for the code (up to 6s), so the card opens
       with the code on it rather than a promise. */
    var welcomePending = false;
    var joinFlow = false;
    var profileDone = false;
    var gates = { points: false, bridge: false };
    function welcomeGate(which) {
      gates[which] = true;
      if (!welcomePending || !gates.points || !gates.bridge) return;
      welcomePending = false;
      if (profileWanted()) { startProfile(); return; }
      openPanel('welcome');
      goForYou();
    }

    /* ---------- email consent nudge ----------
       Members who have not agreed to marketing emails see the pill
       alternate between their points and an offer of bonus points for
       joining the emails. Tapping it while the offer shows opens the panel
       in its member mode, where one button signs them up. Stops for the
       session once tapped; gone for good once they sign up here or Shopify
       has their consent. */
    var nudgeTimer = 0;
    var nudgeKindNow = '';
    var PNUDGED_KEY = 'sc-lpill-nudged-profile';
    function consentNudgeWanted() {
      if (!cfg.member || !cfg.nudge || cfg.subscribed || !cfg.email || !cfg.klaviyoKey || !cfg.klaviyoList) return false;
      if (cfg.offerEligible && !offerApplied) return false;
      try {
        if (sessionStorage.getItem(NUDGED_KEY) === '1') return false;
        if (localStorage.getItem(SUB_KEY) === '1') return false;
      } catch (e) {}
      return true;
    }
    /* The questions for points: members without answers, or with answers old enough to earn again. Once per session. */
    function profileNudgeWanted() {
      if (!cfg.member || !pointsOn() || !cfg.profile.nudgeOn) return false;
      if (cfg.offerEligible && !offerApplied) return false;
      try { if (sessionStorage.getItem(PNUDGED_KEY) === '1') return false; } catch (e) {}
      return profileWanted() || profileStale();
    }
    function nudgeKind() {
      if (consentNudgeWanted()) return 'consent';
      if (profileNudgeWanted()) return profileWanted() ? 'profile' : 'refresh';
      return '';
    }
    function nudgeWanted() { return !!nudgeKind(); }
    function nudgeText() {
      if (nudgeKindNow === 'profile') return fill(cfg.profile.nudge);
      if (nudgeKindNow === 'refresh') return fill(cfg.profile.refreshNudge);
      return fill(cfg.text.consent);
    }
    function startNudge() {
      if (nudgeTimer || !nudgeWanted()) return;
      nudgeTimer = setInterval(function () {
        if (root.classList.contains('is-min') || root.classList.contains('is-away')) return;
        var next = showingNudge ? '' : nudgeKind();
        if (!showingNudge && !next) { clearInterval(nudgeTimer); nudgeTimer = 0; return; }
        root.classList.add('is-swap');
        setTimeout(function () {
          showingNudge = !showingNudge;
          if (showingNudge) { nudgeKindNow = next; track(next === 'consent' ? 'consent_shown' : next + '_nudge_shown'); }
          render();
          root.classList.remove('is-swap');
        }, 200);
      }, 5000);
    }
    /* The email nudge is done (consent given, or tapped); another kind may still apply. */
    function stopNudge() {
      clearInterval(nudgeTimer);
      nudgeTimer = 0;
      showingNudge = false;
      try { sessionStorage.setItem(NUDGED_KEY, '1'); } catch (e) {}
      render();
      startNudge();
    }
    function stopProfileNudge() {
      try { sessionStorage.setItem(PNUDGED_KEY, '1'); } catch (e) {}
      if (nudgeKindNow === 'profile' || nudgeKindNow === 'refresh') {
        clearInterval(nudgeTimer);
        nudgeTimer = 0;
        showingNudge = false;
        nudgeKindNow = '';
        render();
      }
    }
    /* Any Rivo slideout on screen, whichever screen it shows. */
    function drawerVisible() {
      var els = document.querySelectorAll('.rivo-slideout__container');
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.height > 0 && r.width > 0 && getComputedStyle(els[i]).visibility !== 'hidden') return true;
      }
      return false;
    }
    /* Rivo's drawer counts as open while its dialog is on screen. */
    function rivoOpen() {
      var c = document.querySelector('.rivo-slideout__container[aria-labelledby="rivo-account-dialog-title"]');
      if (!c || c.closest('[aria-hidden="true"]')) return false;
      var r = c.getBoundingClientRect();
      return r.height > 0 && r.top < window.innerHeight && getComputedStyle(c).visibility !== 'hidden';
    }
    /* Live balance from Rivo. Its API has answered both by callback and by
       promise, with the balance as points_balance or points_tally, so all
       are accepted and the first answer wins. */
    function fetchPoints() {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        var R = window.RivoJS;
        if (R && typeof R.getCustomerDetails === 'function') {
          clearInterval(timer);
          var done = false;
          var got = function (c) {
            if (done || !c) return;
            var p = Number(c.points_balance != null ? c.points_balance : c.points_tally);
            if (isNaN(p)) return;
            done = true;
            try { sessionStorage.setItem(PTS_KEY, String(p)); } catch (e) {}
            showPoints(p);
          };
          try {
            var r = R.getCustomerDetails(got);
            if (r && typeof r.then === 'function') r.then(got, function () {});
          } catch (e) {}
        } else if (tries >= 50) {
          clearInterval(timer);
        }
      }, 200);
    }
    function member() {
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      applyOffer();
      try {
        if (sessionStorage.getItem(JOIN_KEY) === '1') {
          sessionStorage.removeItem(JOIN_KEY);
          offerPromised = sessionStorage.getItem(PROMISED_KEY) === '1';
          sessionStorage.removeItem(PROMISED_KEY);
          welcomePending = true;
          joinFlow = true;
          /* If Rivo never answers, still say hello. */
          setTimeout(function () { welcomeGate('points'); }, 4000);
          /* The two questions come first and give the code time to arrive; without them, wait a few seconds for it. */
          if (profileWanted() || !bridgeBusy()) welcomeGate('bridge'); else setTimeout(function () { welcomeGate('bridge'); }, 6000);
        }
      } catch (e) {}
      var start = null;
      try { var c = sessionStorage.getItem(PTS_KEY); if (c !== null && c !== '') start = Number(c); } catch (e) {}
      if ((start === null || isNaN(start)) && cfg.points !== '' && cfg.points != null) start = Number(cfg.points);
      if (start !== null && !isNaN(start)) showPoints(start); else setText(fill(cfg.text.memberLoading));
      fetchPoints();
    }

    /* ---------- placement ---------- */
    var obstacles = ['.sticky-atc-wrapper:not(.hidden)', '#shopify-pc__banner', '.lp-sticky.is-on'];
    var rivoWasOpen = false;
    function place() {
      var lift = 0;
      obstacles.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          var r = el.getBoundingClientRect();
          var cs = getComputedStyle(el);
          if (cs.display === 'none' || cs.visibility === 'hidden' || r.height === 0) return;
          if (r.top < window.innerHeight && r.bottom >= window.innerHeight - 2) lift = Math.max(lift, window.innerHeight - r.top);
        });
      });
      root.style.setProperty('--lpill-lift', lift ? (-lift - 4) + 'px' : '0px');
      var cart = document.querySelector('div#mini-cart');
      var rivo = rivoOpen();
      var away = !!(cart && !cart.classList.contains('hidden')) || (panel && !panel.hidden) || rivo;
      root.classList.toggle('is-away', away);
      if (rivoWasOpen && !rivo && cfg.member) fetchPoints();
      rivoWasOpen = !!rivo;
    }
    var raf = 0;
    function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; place(); }); }
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    if (window.MutationObserver) new MutationObserver(schedule).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'style', 'aria-hidden'] });

    /* ---------- minimise ---------- */
    minBtn.addEventListener('click', function () {
      root.classList.add('is-min');
      try { sessionStorage.setItem(MIN_KEY, '1'); } catch (e) {}
      track('minimise');
    });

    /* ---------- for other scripts, such as the "My skin" section in the Rivo drawer ---------- */
    window.scLoyaltyPill = {
      /* Current answers and the option lists, or null when signed out or the questions are off. */
      profile: function () {
        if (!cfg.member || !cfg.profile || !cfg.profile.enabled) return null;
        return {
          type: current.type,
          concerns: current.concerns.slice(),
          updatedAt: cfg.profile.updatedAt || '',
          points: pointsOn() ? Number(cfg.profile.points) : 0,
          stale: profileStale(),
          types: cfg.profile.types.filter(function (o) { return o.label; }),
          concernOptions: cfg.profile.concerns.filter(function (o) { return o.label; })
        };
      },
      /* Save new answers from elsewhere: Klaviyo and the customer record, same as the panel. */
      saveProfile: function (type, concerns) {
        if (!cfg.member) return Promise.reject(new Error('not signed in'));
        profileEdit = true;
        profileAnswers = { type: String(type || ''), concerns: Array.isArray(concerns) ? concerns.map(String) : [] };
        track('profile_edit', { lp_type: profileAnswers.type, lp_concerns: profileAnswers.concerns.join(', '), lp_from: 'drawer' });
        rememberProfile();
        stopProfileNudge();
        pointsDue = false;
        /* Resolves with the bridge's answer, so the caller can say when points are on their way ({pointsDue: true}). */
        var p = Promise.all([sendProfile(), storeProfile()]).then(function (r) { return r[1] || {}; });
        profileEdit = false;
        return p;
      },
      editProfile: startProfileEdit
    };

    /* ---------- open by itself (Theme settings > Loyalty pill > Open by itself) ---------- */
    /* Anything else on screen: the bag, Rivo's drawer, the quick view (it locks the page scroll), a Klaviyo pop-up, or any other open dialog. */
    function overlayOpen() {
      if (klaviyoOpen) return true;
      var cart = document.querySelector('div#mini-cart');
      if (cart && !cart.classList.contains('hidden')) return true;
      if (drawerVisible()) return true;
      if (document.body.classList.contains('overflow-hidden')) return true;
      var ds = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
      for (var i = 0; i < ds.length; i++) {
        if (ds[i] === panel) continue;
        var r = ds[i].getBoundingClientRect(), cs = getComputedStyle(ds[i]);
        if (r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0.05) return true;
      }
      return false;
    }
    /* Why it must not open now, or '' when it may. */
    function autoBlocked() {
      var a = cfg.auto;
      if (!a || cfg.member || !panel || btn.tagName !== 'BUTTON') return 'off';
      if (a.who !== 'guests' && state !== 'guest') return 'known';
      if (pagesThisVisit < Number(a.pages || 1)) return 'pages';
      if ((a.device === 'desktop' && !desktop()) || (a.device === 'mobile' && desktop())) return 'device';
      var path = location.pathname.toLowerCase();
      if ((a.skip || []).some(function (s) { s = String(s || '').replace(/^https?:\/\/[^\/]+/, '').trim(); return s && path.indexOf(s) > -1; })) return 'page';
      if (/[?&]sc=skin(&|$)/.test(location.search)) return 'deeplink';
      if (root.classList.contains('is-min')) return 'minimised';
      try {
        if (sessionStorage.getItem(AUTO_DONE_KEY) === '1') return 'done';
        if (sessionStorage.getItem(OPENED_KEY) === '1') return 'opened';
        if (sessionStorage.getItem(JOIN_KEY) === '1') return 'joining';
        if (localStorage.getItem(SUB_KEY) === '1') return 'joined';
        if (a.klaviyo && sessionStorage.getItem(KL_SHOWN_KEY) === '1') return 'klaviyo';
        var at = Number(localStorage.getItem(AUTO_AT_KEY) || 0);
        if (at && Date.now() - at < Number(a.restDays || 0) * 864e5) return 'resting';
      } catch (e) { return 'storage'; }
      return '';
    }
    function autoOpen() {
      var a = cfg.auto;
      if (autoBlocked()) return;
      var fired = false, waits = 0;
      function go(how) {
        if (fired) return;
        if (autoBlocked()) { fired = true; return; }
        if (!panel.hidden || overlayOpen()) {
          /* Something else is on screen: look again shortly, for up to half a minute. */
          if (++waits > 20) { fired = true; return; }
          setTimeout(function () { go(how); }, 1500);
          return;
        }
        fired = true;
        try { sessionStorage.setItem(AUTO_DONE_KEY, '1'); localStorage.setItem(AUTO_AT_KEY, String(Date.now())); } catch (e) {}
        autoOpening = true;
        try { openPanel(state === 'known' ? 'known' : 'guest'); } finally { autoOpening = false; }
        autoShowing = true;
        track('auto_open', { lp_trigger: how, lp_pages: pagesThisVisit });
      }
      var how = a.trigger || 'delay';
      if (how === 'exit' && !desktop()) how = 'delay';
      var wait = Math.max(1, Number(a.delay) || 5) * 1000;
      if (how === 'now') { setTimeout(function () { go('now'); }, 1000); return; }
      if (how === 'scroll') {
        var need = Math.min(95, Math.max(5, Number(a.scroll) || 40)) / 100;
        var check = function () {
          var h = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight) - window.innerHeight;
          /* A page too short to scroll counts once they have had the seconds on it. */
          if (h < 50) { window.removeEventListener('scroll', check); setTimeout(function () { go('scroll'); }, wait); return; }
          if (window.scrollY / h >= need) { window.removeEventListener('scroll', check); go('scroll'); }
        };
        window.addEventListener('scroll', check, { passive: true });
        check();
        return;
      }
      if (how === 'exit') {
        /* The pointer leaving through the top of the window, towards the tabs or the address bar; not in the first two seconds. */
        var armed = false;
        setTimeout(function () { armed = true; }, 2000);
        var out = function (e) {
          if (!armed || e.relatedTarget || e.clientY > 0) return;
          document.removeEventListener('mouseout', out);
          go('exit');
        };
        document.addEventListener('mouseout', out);
        return;
      }
      setTimeout(function () { go('delay'); }, wait);
    }

    /* ---------- go ---------- */
    function start() {
      /* /?sc=skin (from an email): straight to the questions. Members see no
         hello card first, and the link is dropped from the address bar;
         guests get the sign-in and come back with the link still on. */
      var deep = /[?&]sc=skin(&|$)/.test(location.search);
      if (deep && cfg.member) {
        try { sessionStorage.removeItem(JOIN_KEY); } catch (e) {}
        try { history.replaceState(null, '', location.pathname + location.search.replace(/([?&])sc=skin(&|$)/, function (m, a, b) { return b ? a : ''; }).replace(/\?$/, '') + location.hash); } catch (e) {}
      }
      if (cfg.member) member(); else guest();
      root.hidden = false;
      place();
      requestAnimationFrame(function () { root.classList.add('is-in'); });
      track('shown');
      if (!deep) autoOpen();
      if (deep) {
        track('deeplink_skin');
        setTimeout(function () {
          if (!cfg.member) { openPanel(state === 'known' ? 'known' : 'guest'); return; }
          if (!cfg.profile || !cfg.profile.enabled) return;
          if (current.type || current.concerns.length) startProfileEdit(); else startProfile();
        }, 400);
      }
    }
    if (document.readyState === 'complete') setTimeout(start, 1200);
    else window.addEventListener('load', function () { setTimeout(start, 1200); });
  })();
